export default "__VITE_ASSET__DvSzMwag__"